export const FETCH_BID_PREFERENCE_CLASSES_REQUEST = 'FETCH_BID_PREFERENCE_CLASSES_REQUEST';
export const FETCH_BID_PREFERENCE_CLASSES_FAILURE = 'FETCH_BID_PREFERENCE_CLASSES_FAILURE';
export const FETCH_BID_PREFERENCE_CLASSES_SUCCESS = 'FETCH_BID_PREFERENCE_CLASSES_SUCCESS';
export const FETCH_BID_OPTIONS_ATTRIBUTES_REQUEST = 'FETCH_BID_OPTIONS_ATTRIBUTES_REQUEST';
export const FETCH_BID_OPTIONS_ATTRIBUTES_FAILURE = 'FETCH_BID_OPTIONS_ATTRIBUTES_FAILURE';
export const FETCH_BID_OPTIONS_ATTRIBUTES_SUCCESS = 'FETCH_BID_OPTIONS_ATTRIBUTES_SUCCESS';
export const FETCH_PAIRING_DATE_FAILURE = 'FETCH_PAIRING_DATE_FAILURE';
export const FETCH_PAIRING_DATE_SUCCESS = 'FETCH_PAIRING_DATE_SUCCESS';
